export default {
  disasterAuthorization: {
    title: 'Portal Nutzer Anmeldung',
    text: 'Bitte wählen Sie Ihren Daten-Provider und geben Sie den passenden Schlüssel Ihres HeiGIT-Disaster-Portal-Nutzers ein. Wenn Sie noch keinen Nutzer haben, beantragen Sie einen, indem Sie eine E-Mail an support[at]openrouteservice.heigit.org senden, in welcher Ihr Anwendungsfall angegeben ist. Falls Sie keinen Schlüssel eingeben, können Sie die App im schreibgeschützten Modus verwenden.',
    save: 'Speichern',
    enterTheAuthorizationKey: 'Geben Sie den Autorisierungsschlüssel ein',
    selectProvider: 'Wählen Sie Ihren Datenanbieter',
    useReadOnly: 'Schreibgeschützten Modus',
    authenticateAsAdmin: 'Hier den Administrationsmodus aktivieren',
    insertAValidKey: 'Ein gültiger Schlüssel muss eingesteckt sein',
    insertAProvider: 'Es muss ein zu Ihrer Berechtigung passender Datenanbieter ausgewählt werden'
  }
}
